module.exports = __webpack_public_path__ + "static/media/email-verification.d288f952.png";